import { render, staticRenderFns } from "./TarifsSanteSenior.vue?vue&type=template&id=00d6ab81&scoped=true&"
import script from "./TarifsSanteSenior.vue?vue&type=script&lang=js&"
export * from "./TarifsSanteSenior.vue?vue&type=script&lang=js&"
import style0 from "./TarifsSanteSenior.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TarifsSanteSenior.vue?vue&type=style&index=1&id=00d6ab81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d6ab81",
  null
  
)

export default component.exports